import endpoints from "../constants/env/middletier";
import React, { useState, useEffect, useRef} from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import AddProjectForm from '../components/AddProjectForm';

export default function IssuesPage() {
    const [allIssues, setAllIssues] = useState([]);
    const [dialogVisible, setDialogVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [columnExpanded, setColumnExpanded] = useState(false);
    const [addIssueFormVisible, setAddIssueFormVisible] = useState(false);

    const [columns, setColumns] = useState([
        {field: 'description', header: 'description'},
        {field: 'priority', header: 'priority'},
        {field: 'status', header: 'status'},
        {field: 'scheduleImpact', header: 'scheduleImpact'},
        {field: 'assetId', header: 'assetId'}
    ]);

    const sortByName = (a, b) => a.name.localeCompare(b.name);

    const fetchIssues = async () => {
        try {
            const response = await fetch(Endpoints["issue"], {
                method: "GET"
            });
            if (!response.ok) throw new Error("Bad response");
            const data = await response.json();
            const newSource = [...data].sort(sortByName);

            setAllIssues(newSource);
            console.log(data);
        } catch (error) {
            console.error("Failed to fetch clients:", error);
        }
    };

    useEffect(() => {
        fetchIssues();
    }, []);

    const handleAddColumns = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            if(columnExpanded){
                setColumns(prev => [
                    {field: 'description', header: 'description'},
                    {field: 'priority', header: 'priority'},
                    {field: 'status', header: 'status'},
                    {field: 'scheduleImpact', header: 'scheduleImpact'},
                    {field: 'assetId', header: 'assetId'}
                ]);
                setColumnExpanded(false);
            } else {
                setColumns(prev => [
                    ...prev,
                    {field: 'locationId', header: 'locationId'},
                    {field: 'subtaskId', header: 'subtaskId'},
                    {field: 'drawingRef', header: 'drawingRef'},
                    {field: 'specRef', header: 'specRef'},
                    {field: 'internalRef', header: 'internalRef'},
                    {field: 'procoreRef', header: 'procoreRef'},
                    {field: 'reportedBy', header: 'reportedBy'},
                    {field: 'reportedOn', header: 'reportedOn'},
                    {field: 'issueType', header: 'issueType'},
                    {field: 'issueRootCause', header: 'issueRootCause'},
                    {field: 'recommendedAction', header: 'recommendedAction'},
                    {field: 'createdAt', header: 'createdAt'},
                    {field: 'updatedAt', header: 'updatedAt'}
                ]);
                setColumnExpanded(true);
            }
        } catch (error) {
            console.error("Error submitting form:", error);
        } finally {
            setLoading(false);
        }
    };

    const header = (
        <div className="flex align-items-center justify-content-between">
            <span className="text-xl text-900 font-bold">
                Issues
            </span>

            <div className="p-inputgroup" style={{ width: 'auto' }}>
                <Button icon="pi pi-plus" rounded text severity="secondary" onClick={() => setAddIssueFormVisible(true)} />
                <Button icon="pi pi-refresh" rounded text severity="secondary" onClick={() => fetchIssues()} />
                <Button icon={columnExpanded ? 'pi pi-caret-left' : 'pi pi-caret-right'}  label={columnExpanded ? 'Less Columns...' : 'All Columns...'}
                        text severity="secondary" onClick={handleAddColumns} />
            </div>
        </div>
    );

    const header2 = (
        <div className="flex flex-wrap align-items-center justify-content-between gap-2">
            <span className="text-xl text-900 font-bold">Projects</span>
        </div>
    );

    return (
        <>
            <br />
            <br />
            <br />

            <div className="card">
                <DataTable value={allIssues} header={header} tableStyle={{ minWidth: '50rem' }}>
                    {columns.map((col, i) => (
                        <Column key={col.field} field={col.field} header={col.header} />
                    ))}
                </DataTable>
            </div>

            <AddProjectForm
                addProjectFormVisible={addIssueFormVisible}
                setAddProjectFormVisible={setAddIssueFormVisible}
            />

        </ >
    );
}























